var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 86",
    style: {
      enableBackground: "new 0 0 43 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA0B2A;}\r\n\t.st1{fill:none;stroke:#EA0B2A;stroke-width:4;stroke-linecap:round;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.1,
    cy: 15.8,
    r: 12.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1,15.8v67.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDown);
export default __webpack_public_path__ + "static/media/TimelineDown.3e3574ff768dd43ae09b9b4647d8ce14.svg";
export { ForwardRef as ReactComponent };